<template>
    <div class="newcontent">
        <NavBar></NavBar>
        <div class="nw-content">
            <div>
            <h3> {{$t('Welcome to Panda Mandarin')}} </h3>
            <span> {{$t('Please tell us a little about yourself')}} </span>
            </div>
         <div>
            <div>
                    <el-form :model="ruleForm"  :rules="rules" ref="ruleForm"  :hide-required-asterisk="true" label-position="top"  >
                        <el-form-item :label="$t('Phone Number')" prop="mobile_code">
                            <el-input  disabled v-model="ruleForm.mobile_code"  ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Kid(s) Nickname')" prop="nickname">
                            <el-input  v-model="ruleForm.nickname"  :placeholder=" $t('Kid(s) Nickname')" ></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Email address')" prop="email">
                            <el-input v-model="ruleForm.email"  placeholder="example@email.com"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('Wechat ID')" prop="wechat_id">
                            <el-input v-model="ruleForm.wechat_id"  placeholder="wechat ID"></el-input>
                        </el-form-item>
                        <el-form-item class="el-captcha" >
                            <div ref="captcha" style=" background: #00000;"></div>
                            <!-- <span v-if="dialogVisible"> {{$t('Please verify')}} </span> -->
                        </el-form-item>
                        <el-form-item class="form-botton">
                            <el-button class="wp-button" type="primary" @click="submitForm('ruleForm')"> {{$t('Submit')}} </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import i18n from "../locales/i18n";
import { joinUser, getCountries, recordClick } from '../api';
import { loadingData } from '../utils';
import { setStore, keys } from '../store';
import { auto } from 'html-webpack-plugin/lib/chunksorter';
  export default {
      components: {
    NavBar,
  },
    data() {
      return {
        ruleForm: {
            nickname: '',
            email: '',
            mobile: '',
            country_code:'',
            wechat_id:'',
            mobile_code:''

        },
        rules: {
           email: [
            {
                required: true,
                message: i18n.t("Please enter your email"),
                trigger: "blur"
            },
            {
                type: "email",
                message: i18n.t("Please enter the correct email address"),
                trigger: ["blur", "change"]
            }
         ],
        },
        dialogVisible: false,
      input:'',
      screenWidth:'',
      messagecode:false
      };
    },
    mounted(){


        var that=this
       that.screenWidth  =document.body.clientWidth ||window.screenWidth;
        window.addEventListener("resize", function() {
                        return(() => {
                         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
                            //  console.log(that.screenWidth)
                        })();
                    });
        this.ruleForm.country_code=this.$route.params.country_code
        this.ruleForm.mobile=this.$route.params.phone
        if(this.ruleForm.country_code!=null&&this.ruleForm.mobile!=null){
            this.ruleForm.mobile_code='+'+this.ruleForm.country_code +' '+this.ruleForm.mobile
        }else{
            this.$router.push({ path: '/login' });
        }
        var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
              lang :i18n.locale=='en'?'en':'zh-CN',
              mode: 'float',
              apiVersion: 2,
              popupStyles: {
                 bottom:'0px',
                 top:'auto',
              },
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                  if (err) {
                      this.input=''
                  }
                  if(data){
                      this.input=data.validate
                      this.dialogVisible==false
                    //   this.submitForm('ruleForm')
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
		      self.instance && self.instance.refresh();
		    });
    },
    methods: {
        async submitForm(ruleForm) {
            await loadingData(async () => {
                try {
                    let form = {
                        mobile: this.ruleForm.mobile,
                        email: this.ruleForm.email,
                        country_code: this.ruleForm.country_code,
                        child_nickname: this.ruleForm.nickname,
                        wechat_id: this.ruleForm.wechat_id,
                        landingpage_id: 14,
                        utm_source:'pricing',
                        utm_medium:'register',
                        captcha:this.input,
                        ...this.$route.query,

                    };
                    this.$refs[ruleForm].validate(async (valid) => {
                        if (valid) {
                             if(this.input==''){
                                this.dialogVisible=true
                                return
                            }else{
                            this.input=''
                            let userInfo = await joinUser(form);
                            setStore(keys.userInfo, userInfo);
                            await recordClick(1, userInfo.user_sn, 'landingpage-id:14');
                            if (userInfo.name) this.$router.push({ path: '/nuinfo',query:{invite_code:userInfo.invite_code} });
                            // setTimeout(() => {
                            //     if (userInfo.name) this.$router.push({ path: '/nuinfo',query:{invite_code:userInfo.invite_code} });
                            // }, 1000);
                            }
                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                } catch (error) {
                    this.status = false;
                }
            });
        },
    }
  }
</script>
<style lang="less" scoped>
/deep/    .yidun_intellisense--light .yidun_intelli-control{
        background-color: rgb(233, 233, 233);
}
.el-captcha{
    margin: 20px 0 0;
}
/deep/.captchaimg{
    // width: 40%;
    margin-bottom: 20px;
}
/deep/.el-dialog{
    text-align: center;
    padding: 10px 20px;
    .el-input{
        width: 80%;
    }
}
/deep/.el-dialog__footer{
    text-align: center;
}
/deep/.el-dialog__wrapper{
    z-index: 99999999999 !important;
}
.dialog-span{
    margin-bottom: 30px;
    display: block;
}
.s-canvas{
    margin-bottom: 20px;
}

.newcontent{
    background: #fcfcfc;
    height: 100vh;
}
.nw-content{
    width: 600px;
    margin: 0 auto 0;
    display: flex;
        flex-direction:column;
        justify-content:center;
        height: calc(100vh - 100px);
    div{
        h3{
            font-family: ' Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 28px;
            line-height: 36px;
            color: #111827;
            text-align: center;
            margin: 0;
        }
        span{
            display: block;
            font-family: 'Sofia Pro';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            color: #6B7280;
            text-align: center;
            margin: 8px auto 0;
        }
    }
    /deep/.el-input__inner{
        border: 1px solid #D1D5DB;
    }
    /deep/.el-form{
        margin: 20px auto 0;
        padding: 0 20px;
        .el-form-item{
            margin-bottom: 15px;
            .el-input__inner{
                font-family: 'Sofia Pro';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                color: #9CA3AF;

                box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
                border-radius: 6px;
            }
        }
        .form-botton{
                margin-top: 20px;
                .el-button--primary{
                    background: #B60504;
                    border-radius: 43px;
                    span{
                        font-family:  Sofia Pro SemiBold;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                }
            }
        .el-form-item__label{
            padding: 0;
            margin-bottom: 4px;
            font-family:  Sofia Pro SemiBold;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: #111827;
        }
    }

}
@media screen and (max-width: @device) {
    /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    }
    .newcontent{
    background: #F5F5F5;
    height: 100%;
    overflow: hidden;
}
    .nw-content{
    width: 100%;
    margin: 37px auto 0;
     /deep/.el-form{
         margin: 52px auto 0;
         .form-botton{
                margin: 22px auto 57px;
        }
     }
    }
}
  /deep/.wp-input .el-input-group__prepend:focus-within{
    border:1px solid hsl(0, 0%, 0%);
  }
   /deep/.el-input__inner:focus{
 border:1px solid hsl(0, 0%, 0%);
  }
  /deep/.nw-content .el-form .el-form-item .is-disabled .el-input__inner{
      background: #E8E8E8;
  }
</style>



// WEBPACK FOOTER //
// src/views/newUser.vue